<template>
	<div class="wei">
		<div class="wei_box">
			<div class="more">
				<img class="moreimg" src="../static/home/xia.png" alt="">
				<div class="more_box">
					<span v-if="lang==1">服务导向</span>
					<span v-if="lang==2">service</span>
					<span v-if="lang==3">サービスガイド</span>
					<span v-if="lang==4">서비스 가이드</span>
				</div>
			</div>
			<div class="wei_option">
				<div class="w_box" @click="nvu(0)">
					<span v-if="lang==1">怎样到景区</span>
					<span v-if="lang==2">go area</span>
					<span v-if="lang==3">観光地へ</span>
					<span v-if="lang==4">관광지에 가다</span>
				</div>
				<!-- <div class="w_box" @click="nvu(1)">
					
					<span v-if="lang==1">列车时刻</span>
					<span v-if="lang==2">Train</span>
					<span v-if="lang==3">列車時刻</span>
					<span v-if="lang==4">열차 시간</span>
				</div> -->
				<div class="w_box" @click="nvu(2)">
					
					<span v-if="lang==1">购物指南</span>
					<span v-if="lang==2">Shopping</span>
					<span v-if="lang==3">ショッピングガイド</span>
					<span v-if="lang==4">쇼핑 가이드</span>
				</div>
				<div class="w_box" @click="nvu(3)">
					
					<span v-if="lang==1">餐饮美食</span>
					<span v-if="lang==2">delicacy</span>
					<span v-if="lang==3">グルメ</span>
					<span v-if="lang==4">음식 음식</span>
				</div>
				<div class="w_box" @click="nvu(4)">
					
					<span v-if="lang==1">酒店住宿</span>
					<span v-if="lang==2">stay</span>
					<span v-if="lang==3">宿泊する</span>
					<span v-if="lang==4">숙박</span>
				</div>
				<div class="w_box" @click="nvu(5)">
					
					<span v-if="lang==1">门票预订</span>
					<span v-if="lang==2">book</span>
					<span v-if="lang==3">チケット予約</span>
					<span v-if="lang==4">티켓 예약</span>
				</div>
			</div>
			<div class="erwei_name">
				
				<span v-if="lang==1">扫码关注微信公众号</span>
				<span v-if="lang==2">WeChat QR code scanning</span>
				<span v-if="lang==3">ウィーチャットスキャンコード</span>
				<span v-if="lang==4">위챗 스캔</span>
			</div>
			<div class="erwei">
				<img src="../static/home/erwei.png" alt="">
			</div>
			
		</div>
	</div>
</template>

<script>
	
	export default {
		data() {
			return {
				lang:1,		//语言
			}
		},
		created() {
			this.lang = JSON.parse(localStorage.getItem("langs")) || 1
			
		},
		methods:{
			nvu(e){
				if(e==0){
					if(this.$route.name == 'serves'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'serves',query:{nums:0}})
					}
				}
				if(e==1){
					if(this.$route.name == 'serves'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'serves',query:{nums:1}})
					}
				}
				
				
				if(e==2){
					if(this.$route.name == 'online'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'online',query:{nums:3}})
					}
				}
				
				
				if(e==3){
					if(this.$route.name == 'online'){
						this.$router.replace('/refresh?num=0')
					}else{
						this.$router.push({name:'online',query:{nums:0}})
					}
				}
				if(e==4){
					if(this.$route.name == 'online'){
						this.$router.replace('/refresh?num=1')
					}else{
						this.$router.push({name:'online',query:{nums:1}})
					}
				}
				if(e==5){
					if(this.$route.name == 'online'){
						this.$router.replace('/refresh?num=2')
					}else{
						this.$router.push({name:'online',query:{nums:2}})
					}
				}
				
			}
			
		},
		
	}
</script>

<style scoped lang="less">
	//
	.wei{
		width: 175px;
		height: 338px;
		border-radius: 20px;
		background-color: #fff;
		position: absolute;
		z-index: 10;
		right: 0;
		top: 50%;
		transform:translateY(-50%);
		color: #333333;
		cursor:pointer;
	}
	.wei_box{
		margin: auto;
		width: 161px;
	}
	.more{
		box-sizing: border-box;
		padding-top: 28px;
		height: 66px;
		border-bottom: 1px solid #e3e3e3;
		display: flex;
		justify-content: center;
	}
	.moreimg{
		width: 24px;
		height: 14px;
		margin-right: 14px;
	}
	.more_box{
		font-size: 18px;
		line-height: 18px;
	}
	.wei_option{
		padding-top: 1px;
		height: 89px;
		border-bottom: 1px solid #e3e3e3;
		display: flex;
		flex-wrap: wrap;
	}
	
	.w_box{
		width: 80px;
		height: 14px;
		line-height: 14px;
		font-size: 12px;
		text-align: center;
		margin-top: 6px;
		font-family: "微软雅黑";
	}
	.w_box:hover{
		color: #e3742a;
	}
	.erwei{
		margin: auto;
		margin-top: 19px;
		width: 113px;
		height: 113px;
		background-color: #e3742a;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.erwei_name{
		font-size: 12px;
		text-align: center;
		margin-top: 13px;
		overflow: hidden;           //超出隐藏
		white-space: nowrap;       //超出不换行
		text-overflow:ellipsis;    //超出显示省略号
	}
</style>